
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/returning-user",
      function () {
        return require("private-next-pages/docs/link/returning-user.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/returning-user"])
      });
    }
  